module.exports = __webpack_public_path__ + "img/img_11.d7992e08.jpg";